/**
 * DotStatus — canon section 9 status dot primitive (P5.6).
 *
 * Canon v3 раздел 9: «Дот-статус: точечный 8px @ .45.» Standardised marker
 * for connection state, notification presence, "online", сорт-team
 * presence chips, etc. Replaces inline w-2 h-2 bg-… literals that
 * drifted across components.
 *
 * Tones map to canon semantic palette + accent + neutral:
 *   ok / warn / bad / accent (iris) / muted (ink-3)
 */
import type { CSSProperties } from "react";
import { DOT_TONE } from "../../lib/tonePalette";

export type DotTone = "ok" | "warn" | "bad" | "accent" | "muted" | "swim" | "bike" | "run";

export interface DotStatusProps {
  tone?: DotTone;
  /** Override size in px. Default 8 (canon). */
  size?: number;
  /** Override alpha. Default 0.45 (canon). */
  alpha?: number;
  /** Pulse animation for live indicators. */
  pulse?: boolean;
  /** Optional aria-label for screen readers. */
  label?: string;
  className?: string;
  testId?: string;
}

export function DotStatus({
  tone = "muted",
  size = 8,
  alpha = 0.45,
  pulse = false,
  label,
  className = "",
  testId = "dot-status",
}: DotStatusProps) {
  const baseColor = DOT_TONE[tone];
  const style: CSSProperties = {
    width: size,
    height: size,
    backgroundColor: baseColor,
    opacity: alpha,
  };
  return (
    <span
      data-testid={testId}
      data-tone={tone}
      role={label ? "status" : undefined}
      aria-label={label}
      className={`inline-block rounded-full ${pulse ? "animate-pulse" : ""} ${className}`.trim()}
      style={style}
    />
  );
}
